import axios from 'axios';
import React, { FC } from 'react';
import { getAEMUrl, getWebLinks } from '../utils';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { Progress } from '@trip-ux/components';
import { sanitizeDOM } from '@trip-ux/common';
import './expFragment.scss';
import { labelsSelector } from '@trip-ux/react-containers';

export const ExpFragmentPage: FC<{ screen: string }> = ({ screen }) => {
  const { userProfile, config, labels } = useSelector((store: ReduxStore) => ({
    userProfile: store.userProfile,
    config: store.config,
    labels: labelsSelector(store)
  }));
  const [htmlData, sethtmlData] = React.useState(undefined);
  const [containerHeight, setContainerHeight] = React.useState('100vh');
  const iframeRef = React.useRef(null);

  const url = getAEMUrl(screen, config.locale, userProfile?.profileType);
  const WeblinkLabel = labels.weblink;

  React.useEffect(() => {
    axios.get(url).then(res => {
      if (screen === 'landing') {
        injectName(res.data);
      } else if (screen === 'resource') {
        injectWeblink(res.data);
      } else if (screen === 'advisorResource') {
        injectWeblink(res.data);
      } else if (screen === 'advisorContactUs') {
        injectWeblink(res.data);
      } else {
        remWhitelabelCss(res.data);
      }
    });
  }, [WeblinkLabel]);
  React.useEffect(() => {
    const checkIframeHeight = () => {
      if (iframeRef.current) {
        const iframeDocument = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
        if (iframeDocument) {
          const height = iframeDocument.body.scrollHeight;
          setContainerHeight(`${height}px`);
        }
      }
    };

    const intervalId = setInterval(checkIframeHeight, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [screen, config.locale]);

  const remWhitelabelCss = res => {
    const result = res.replace('<div>{{> whiteLabeledCss}}</div>', '');
    const lineBreakres = result.replace(/(\r\n|\r|\n)/g, '');
    const response = lineBreakres.replace(
      '<div class="rich-text parbase"><div>    <div class="aem-Grid aem-Grid--12">        <div class="aem-GridColumn aem-GridColumn--default-- aem-GridColumn--tablet-- aem-GridColumn--phone--">            <p class="cq-text-placeholder-ipe" data-emptytext=" Edit Text"></p>        </div>    </div></div></div>',
      '<div class="rich-text parbase" style="display:none"></div>'
    );
    sethtmlData(response);
  };

  const injectName = res => {
    const safeName = sanitizeDOM(userProfile?.name ?? '');
    renderAemToken(res, /\{\{\s*customer\.name\s*\}\}/gi, () => safeName);
  };

  const injectWeblink = res => {
    const lang = config.locale;
    const refCode = userProfile?.whiteLabel?.referenceId;
    const link = getWebLinks(lang, refCode);
    const safeLink = sanitizeDOM(link ?? '').replace(/"/g, '&quot;');
    const safeWeblinkLabel = sanitizeDOM(WeblinkLabel ?? '');
    renderAemToken(res, /\{\{\s*dynamicWeblink\s*\}\}/gi, () => {
      return `<input type="hidden" id="data" value="${safeLink}"><a target="_blank" rel="noopener noreferrer" href="${safeLink}">${safeWeblinkLabel}</a>`;
    });
  };

  const renderAemToken = (res: string, tokenPattern: RegExp, replacement: () => string) => {
    const cleaned = res.replace(/<!--.*?-->/g, '');
    const renderData = cleaned.replace(tokenPattern, replacement);
    remWhitelabelCss(renderData);
  };

  return (
    <>
      {htmlData ? (
        <div className="external-container" style={{ height: containerHeight }}>
          <iframe
            title="external-container"
            aria-labelledby="external-container"
            srcDoc={htmlData}
            ref={iframeRef}
            className="iframe-container"
            sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation allow-top-navigation allow-popups-to-escape-sandbox"
            referrerPolicy="strict-origin-when-cross-origin"
            seamless={true}
            allowFullScreen
          />
        </div>
      ) : (
        <Progress />
      )}
    </>
  );
};

ExpFragmentPage.displayName = 'LandingPage';
export default ExpFragmentPage;
